import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable } from "../../services/visualLibraryService";
import { ButtonModalStyled } from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { routes } from "../../routes";
import {
  LandingPageStyled,
  LandingContainerStyled,
  HeadingStyled,
  LogoStyled,
  TextDisclaimerStyled,
  LogoContainerStyled
} from "./styles/Styled";
import FreeLogo from "../../components/FreeLogo";

const openSignupPinPath = "openSignupPin_passThru";
const openLoginPinPath = "openLoginPin_passThru";
const openHomePagePath = "openHome_passThru";

const ButtonModalFocus = withFocusable(ButtonModalStyled);

class WelcomePage extends React.Component {
  constructor(props) {
    super(props);
    this.moveToLoginPin = this.moveToLoginPin.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.onBack = this.onBack.bind(this);
  }

  moveToLoginPin() {
    this.enterHandler(routes.pin, {
      backDestination: routes.welcome
    });
  }

  moveToSignupPin() {
    this.enterHandler(routes.pinSignup, {
      backDestination: routes.welcome
    });
  }
  moveToHomePage() {
    this.enterHandler(routes.home, null);
  }

  enterHandler(path, locationData) {
    redirectTo.call(this, path, locationData, historyMethods.PUSH);
  }

  onBack() {
    return true;
  }

  render() {
    const { userLocale } = this.props.applicationState;

    return (
      <LandingPageStyled
        background={`http://mena-cdn-lb.aws.playco.com/prd-peg-data/default/bigscreen/images/tizen/welcome/background-${i18n.getDirection()}.png`}
      >
        <LandingContainerStyled>
          <LogoContainerStyled>
            <LogoStyled>
              <FreeLogo height={"3.18rem"} />
            </LogoStyled>
          </LogoContainerStyled>
          <HeadingStyled rank="3" text={i18n.get("pages.welcome.heading")} size="large" />

          <>
            <ButtonModalFocus
              label={i18n.get("global.sections.signup").toUpperCase()}
              focusPath={openSignupPinPath}
              onEnterPress={() => this.moveToSignupPin()}
              onMouseUp={() => this.moveToSignupPin()}
              size="medium"
              dataSnUp={""}
              dataSnDown={`@${openLoginPinPath}`}
              dataSnLeft={""}
              dataSnRight={""}
              userLocale={userLocale}
            />

            <ButtonModalFocus
              label={i18n.get("pages.welcome.login").toUpperCase()}
              focusPath={openLoginPinPath}
              onEnterPress={() => this.moveToLoginPin()}
              onMouseUp={() => this.moveToLoginPin()}
              size="medium"
              dataSnUp={`@${openSignupPinPath}`}
              dataSnDown={`@${openHomePagePath}`}
              dataSnLeft={""}
              dataSnRight={""}
              userLocale={userLocale}
            />
            <ButtonModalFocus
              label={i18n.get("pages.welcome.explore").toUpperCase()}
              focusPath={openHomePagePath}
              onEnterPress={() => this.moveToHomePage()}
              onMouseUp={() => this.moveToHomePage()}
              size="medium"
              dataSnUp={`@${openLoginPinPath}`}
              dataSnDown={""}
              dataSnLeft={""}
              dataSnRight={""}
              userLocale={userLocale}
            />
          </>
          <TextDisclaimerStyled
            text={`${i18n.get("pages.welcome.footer")} ${i18n.get("pages.welcome.footerEmail")}`}
            size="medium"
          />
        </LandingContainerStyled>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(WelcomePage));
